var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 1.875H4.375C3.71216 1.87566 3.07666 2.13927 2.60796 2.60796C2.13927 3.07666 1.87566 3.71216 1.875 4.375V15.625C1.87566 16.2878 2.13927 16.9233 2.60796 17.392C3.07666 17.8607 3.71216 18.1243 4.375 18.125H15.625C16.2878 18.1241 16.9231 17.8604 17.3918 17.3918C17.8604 16.9231 18.1241 16.2878 18.125 15.625V4.375C18.1243 3.71216 17.8607 3.07666 17.392 2.60796C16.9233 2.13927 16.2878 1.87566 15.625 1.875ZM14.2283 7.27667L8.97833 13.5267C8.92089 13.5953 8.84932 13.6508 8.76851 13.6894C8.68769 13.7279 8.59952 13.7486 8.51 13.75H8.49917C8.41164 13.75 8.32509 13.7316 8.24513 13.696C8.16517 13.6604 8.09358 13.6084 8.035 13.5433L5.785 11.0433C5.68545 10.9363 5.62652 10.7978 5.61844 10.6518C5.61035 10.5058 5.65361 10.3616 5.74072 10.2442C5.82783 10.1268 5.95328 10.0436 6.09532 10.0091C6.23736 9.97451 6.38702 9.99076 6.51833 10.055C6.59333 10.0925 6.66 10.1442 6.71333 10.2067L8.4825 12.1733L13.2717 6.47333C13.3801 6.35307 13.531 6.27959 13.6926 6.26838C13.8541 6.25718 14.0137 6.30911 14.1377 6.41325C14.2618 6.51739 14.3405 6.66561 14.3574 6.82666C14.3743 6.98772 14.328 7.14905 14.2283 7.27667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconFilled);
export default __webpack_public_path__ + "static/media/CheckIconFilled.99a18c04b3af8eaeaa78d27e49fe7942.svg";
export { ForwardRef as ReactComponent };